import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { ACTIVE_AUTHORITY } from 'constants/config';

// The OIDC authority must be resolved from the same `address` query param
// used to pick the API host (see `getAuthority`/`ACTIVE_AUTHORITY` in
// `constants/config.ts`), and resolved before this AuthProvider is
// constructed. Never fall back to production when `address=local` was
// explicitly requested: `getAuthority` fails closed by only ever returning
// the local authority for an explicit `address=local`, and production
// otherwise.
//
// `client_secret` is intentionally never set here: `default-client` is
// registered as a Public OpenIddict client in every environment (local and
// production), so this is a public SPA client with no genuine confidential
// secret to protect. Sending any client_secret causes OpenIddict to reject
// the request with `invalid_client` regardless of credentials (AB#350 - the
// same defect class previously fixed for the Web Portal in AB#329/PR145).
// Never reintroduce a hardcoded or env-sourced client_secret here.
const oidcConfig = {
  authority: ACTIVE_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID || 'default-client',
  scope: 'email profile openid offline_access',
  responseType: 'idToken token'
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <FluentProvider theme={webLightTheme} >
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </FluentProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
